export default __webpack_public_path__ + "static/media/ETF_dark.947dbff5.svg";